// extracted by mini-css-extract-plugin
module.exports = {"chat-messages-container":"Chat_chat-messages-container__mAtT1","chat-loading-skeletons":"Chat_chat-loading-skeletons__hXwyW"};